import { Mention } from '@tiptap/extension-mention';
import { NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import { icons } from 'lucide-react';

import CustomDatePicker from './CustomDatePicker';

export interface Attributes {
  color: string;
  iconName: keyof typeof icons;
  id: string;
  label: string;
}

const MentionView: Parameters<typeof ReactNodeViewRenderer>[0] = ({
  node,
  updateAttributes
}) => {
  const { color, iconName, label } = node.attrs as Attributes;

  // eslint-disable-next-line import/namespace
  const Icon = icons[iconName];

  return (
    <NodeViewWrapper
      className={`tag ${color}`}
      contentEditable={false}
    >
      <Icon
        className="shrink-0"
        size={16}
      />
      {label.endsWith(': Custom') ? (
        <CustomDatePicker
          onUpdate={newLabel => {
            updateAttributes({ label: newLabel });
          }}
          text={label}
        />
      ) : (
        <div>@{label}</div>
      )}
    </NodeViewWrapper>
  );
};

const CustomMention = Mention.extend({
  addAttributes() {
    return {
      color: {
        parseHTML: (element: HTMLElement) => element.getAttribute('data-color'),
        renderHTML: (attrs: Attributes) => ({
          'data-color': attrs.color
        })
      },
      iconName: {
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('data-icon-name'),
        renderHTML: (attrs: Attributes) => ({
          'data-icon-name': attrs.iconName
        })
      },
      id: { default: null },
      label: { default: null }
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(MentionView);
  },
  selectable: true
});

export default CustomMention;
